const normalizePath = (value) => {
  const text = String(value || '').trim();
  if (!text || text === '/') return '';
  const withLeadingSlash = text.startsWith('/') ? text : `/${text}`;
  return withLeadingSlash.replace(/\/+$/, '');
};

export const basePathFromScript = (scriptUrl) => {
  if (!scriptUrl) return '';
  try {
    const pathname = new URL(scriptUrl, 'https://kiosk.invalid').pathname;
    const marker = '/assets/';
    const markerIndex = pathname.lastIndexOf(marker);
    return markerIndex >= 0 ? normalizePath(pathname.slice(0, markerIndex)) : '';
  } catch { return ''; }
};

export const basePathFromLocation = (pathname) => {
  const normalized = String(pathname || '/').replace(/\/{2,}/g, '/');
  if (normalized === '/' || normalized === '/index.html') return '';
  const firstSegment = normalized.split('/').filter(Boolean)[0] || '';
  return firstSegment && !firstSegment.includes('.') ? `/${firstSegment}` : '';
};

export const resolveBasePath = ({ configuredBasePath = '', scriptUrl = '', pathname = '/' } = {}) => (
  normalizePath(configuredBasePath) || basePathFromScript(scriptUrl) || basePathFromLocation(pathname)
);

export const joinBasePath = (basePath, absolutePath) => {
  const suffix = `/${String(absolutePath || '').replace(/^\/+/, '')}`;
  return `${normalizePath(basePath)}${suffix}`;
};

export const scopedStorageKey = (basePath, key) => {
  const scope = normalizePath(basePath).slice(1).replace(/[^a-z0-9_-]+/gi, '-').toLowerCase();
  return scope ? `${scope}:${key}` : key;
};

export const scopedCacheName = (basePath, rootName, version) => {
  const scope = normalizePath(basePath).slice(1).replace(/[^a-z0-9_-]+/gi, '-').toLowerCase();
  return `${rootName}${scope ? `-${scope}` : ''}-${version}`;
};

